<template>
    <header class="frontend-style">
        <div class="desktop" :class="fixBW.style">
            <img :src="fixBW.logo" alt="" @click="goPage(pages[0].path)" class="cursorPoint">
            <ul>
                <li
                    v-for="(page,key) in viewPages"
                    @click="page.path?goPage(page.path,null):goPage(null,page.pop)"
                    :class="page.pop&&$route.query.popup==page.pop?
                    'actived'+BWText:page.path==$route.path?
                    'actived'+BWText:''+BWText"
                    v-html="i18nTxt(key)"
                    :key="key"
                >
                </li>
                <li @click="goPage(null,'language')" :class="BWText">
                    <img :src="Images.Home.header.icon" alt="">
                    {{Lang[locales]}}
                </li>
            </ul>
        </div>
        <div class="phone" >
            <img :src="fixBW.logo" alt="" @click="goPage(pages[0].path,null)">
                <div class="lang" @click="goPage(null,'language')" :class="$route.name=='home'?'':'blackTxt'">
                    <img :src="Images.Home.header.icon" alt="">
                    <p>{{locales.slice(5,7)}}</p>
                </div>
        </div>
        <div
         class="phoneNav" :class="Mobile&&$route.query.Popup?'slideOut':''">
            <img :src="Images.Mobile.nav.home" alt="" @click="goPage('/',null)" :class="navActived('home',null)">
            <img :src="Images.Mobile.nav.product" alt="" @click="goPage('/products',null)" :class="navActived('products',null)">
            <img :src="Images.Mobile.nav.quality" alt="" @click="goPage('/manufacture',null)" :class="navActived('manufacture',null)">
            <img :src="Images.Mobile.nav.contact" alt="" @click="goPage(null,'contact')" :class="navActived(null,'contact')">
        </div>
    </header>
</template>
<script>
import i18n from '../../i18n'
import { mapState,mapGetters } from 'vuex'
export default {
    name:'Header',
    props:{
        Fixed:Boolean,
        deviceType:String
    },
    computed:{
        ...mapState('frontend',[
            'Images',
            'locales'
        ]),
        ...mapState('analytic',[
            'clientId'
        ]),
        ...mapGetters('frontend',[
            'Mobile'
        ]),
        viewPages(){
            return this.pages.splice(1,5)
        },
        BWText(){
            return this.$route.name=='home'?' w_type cursorPoint':' b_type cursorPoint'
        },
        fixBW(){
            return this.Fixed?
            {logo:this.Images.Logo.logoWhite,style:'fixed'}:
            {logo:this.$route.name=='home'?
            this.Images.Logo.logoWhite:
            this.Images.Logo.logoBlack,
            style:''}
        },

    },
    mounted(){

    },
    data() {
        return {
            pages:[
                {title:'',path:'/'},
                {title:'Products',path:'/products'},
                // {title:'Wire',path:'/'},
                // {title:'Coating',path:'/'},
                {title:'Quality & Manufacture',path:'/manufacture'},
                {title:'Contact',pop:'contact'},
            ],
            i18nList:[
                'Header.product',
                'Header.quality',
                'Header.contact'
            ],
            Lang:{
                'name_EN':'English',
                'name_CH':'中文'
            },
            Open:false,
            scrolling:0,
            scrollFold:false
        }
    },
    methods:{
        goPage(link,pop){
            if (pop === 'contact') {
                this.$gtag.event('客戶從直接點擊聯絡', {
                    'event_category': this.clientId,
                    'event_label': `直接點擊聯絡按鈕`,
                    'value': 200
                })
            }
            this.$gtag.pageview({
                page_path: link,
            })
            link?this.$router.push({path:link}):
            this.$router.replace({query:{Popup:pop}})
        },
        i18nTxt(key){
            return this.$i18n.t(this.i18nList[key])
        },
        navActived(name,pop){
            return pop&&this.$route.query.Popup?'actived':name == this.$route.name?'actived':''
        },
    },
    watch: {

    },
}
</script>
